export default {
  jsonServer: process.env.VUE_APP_CEPE_API,
  sandboxServer: process.env.VUE_APP_CEPE_SANDBOX_API
};
